import {reactive} from 'vue'
import {ITicket} from '@/types/types'
import {deepClone} from '@/utils/util'
import {ticketApi} from '@/api/common'
// import {loginApi} from '@/api/common'
// import {ILoginFrom} from '@/types/types'
import { ElMessage } from 'element-plus'
import {useRouter} from 'vue-router'
import {useStore} from "vuex"


export default function useWrapper(){
  interface IRawData {
    ticket:ITicket | null
  }
  const store = useStore()
  const rawData = reactive<IRawData>({
    ticket:null
  })


  function getTicket(){
    const data = {}
    ticketApi(data).then((res:any)=>{
      if(res && res.state===0){
        rawData.ticket = res.content
        let ticket = JSON.stringify(deepClone(res.content))
        localStorage.setItem('ticket',ticket)
      }
    })
  }


  return {
    rawData,getTicket
  }
}